<section
    class="hero-row grid gap-1 grid-cols-1 sm:gap-2 @md:grid-cols-2 @xl:grid-cols-3 @5xl:grid-cols-4 @9xl:grid-cols-5"
    aria-label="Filter categories"
>
    <ng-content select="[hero-row]" />
</section>

<section class="filter-row" aria-label="Filters">
    <ng-content />
</section>
